import moment from 'moment';

/**
 * @param {string} dateA
 * @param {string} dateB
 */
const dateSort = (dateA: any, dateB: any) => moment(dateA).diff(moment(dateB));

/**
 *
 * @param {number} a
 * @param {number} b
 */
const defaultSort = (a: any, b: any) => {
  if (a < b) return -1;
  if (b < a) return 1;
  return 0;
};

/**
 *
 * @param {string} strA
 * @param {string} strB
 */

const stringSort = (strA: any = '', strB: any = '') => strA?.localeCompare(strB);

export const Sorter = {
  DEFAULT: defaultSort,
  DATE: dateSort,
  STRING: stringSort,
};

export const sorterParamsHandle = (sorter: any) => {
  if (!sorter?.order) return;
  return {
    sortBy: sorter.field,
    ascendance: sorter.order === 'ascend' ? 'ASC' : 'DESC',
  };
};
